import { render, staticRenderFns } from "./Translates.vue?vue&type=template&id=5fea6d78&scoped=true&"
import script from "./Translates.vue?vue&type=script&lang=js&"
export * from "./Translates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea6d78",
  null
  
)

export default component.exports